import {createContext, useContext} from "react";

export const SiteContext = createContext({});

export const SITE_DEFAULTS = {
  announcement: "",
  welcome_title: "Experience Gujarati *culture, community & commerce.*",
  welcome_sub: "Indian Ocean is an open home for everyone who loves the Gujarati way of life — its food, festivals, faith, crafts, language and warmth. You don't have to be Gujarati. Come to learn, take part, shop authentically or simply experience it.",
  home_title: "Kem cho! Here's what's happening in *Gujarati life today.*",
  home_sub: "Culture, community and commerce — festivals, samaj conversations, authentic products and your personal concierge, in one place.",
  bazaar_title: "Authentic Gujarati *products & services.*",
  bazaar_sub: "Handpicked by our team after detailed evaluation — from Patola silk and Kutch craft to farsan and puja essentials.",
  circles_title: "Find your *samaj.*",
  circles_sub: "Groups for business, garba, food, parenting, satsang and more — open to everyone who loves Gujarati life. Join a samaj to take part.",
  ask_title: "Ask anything about *Gujarati life.*",
  ask_sub: "Customs, recipes, festivals, scriptures, shopping, travel — ask, answer and upvote the best replies.",
  gfi_title: "Your Personal *Concierge.*",
  gfi_sub: "A lifestyle manager and household manager rolled into one — for anyone, anywhere. You don't need to be Gujarati or live in India.",
  gfi_purpose: "Need something done but don't know whom to trust, where to find it, or how to get it done remotely? Your Personal Concierge finds, verifies, books and manages it for you — from everyday household and lifestyle needs to special purchases, occasions and paperwork.",
  gfi_example_1: "Finding, verifying and buying gifts, clothing, jewellery or hard-to-find products — from anywhere in the world.",
  gfi_example_2: "Managing your home — staff, repairs, bills, groceries and maintenance — in India or abroad.",
  gfi_example_3: "Coordinating a purchase, booking or family occasion that is difficult to manage from where you are.",
  events_title: "Garba nights, melas *& gatherings.*",
  events_sub: "Public Gujarati cultural events near you, plus your own gatherings.",
  culture_sub: "Choghadiya, rashifal, scriptures, bhajans, darshan and stories — Gujarati culture for everyone.",
  show_bazaar: true, show_samaj: true, show_ask: true, show_gfi: true, show_culture: true,
};

export function useSite() {
  const c = useContext(SiteContext);
  return (key) => (c[key] === undefined || c[key] === "" ? SITE_DEFAULTS[key] : c[key]);
}

export function Rich({text}) {
  return String(text).split("*").map((part, i) => (i % 2 ? <em key={i}>{part}</em> : <span key={i}>{part}</span>));
}
